import Component from "./GamesPuppyBowlCard";
export default Component;
